import React, { useState } from "react";
import { AlertTriangle, ShieldAlert } from "lucide-react";
import { HowToFix } from "@/components/nds/HowToFix";
import { btnGold, btnRed, field } from "@/components/nds/windows/finance/parts";

/** 409 from the API → explain blocks/warnings and offer override (admins) or proceed (warnings). */
export default function ConflictPrompt({ detail, onResolve, onCancel }) {
  const [reason, setReason] = useState("");
  const hard = detail.code === "hard_block";
  const items = [...detail.blocks, ...detail.warnings];
  return (
    <div data-testid="sch-conflict-prompt" className={`rounded-sm border p-3 space-y-2 ${hard ? "border-red-500/50 bg-red-500/10" : "border-amber-500/50 bg-amber-500/10"}`}>
      <div className="flex items-center gap-2 text-sm font-semibold text-white">
        {hard ? <ShieldAlert className="h-4 w-4 text-red-400" /> : <AlertTriangle className="h-4 w-4 text-amber-400" />}
        {hard ? "Hard block: this would double-book or overfill" : "Warning: staff already booked"}
      </div>
      <ul className="text-xs text-white/85 space-y-1 list-disc pl-5" data-testid="sch-conflict-list">
        {items.slice(0, 8).map((b, i) => (
          <li key={i} className={detail.blocks.includes(b) ? "text-red-200" : "text-amber-200"}>
            {b.message}{b.occurrence_start ? ` (${new Date(b.occurrence_start).toLocaleDateString()})` : ""}
          </li>
        ))}
        {items.length > 8 && <li>…and {items.length - 8} more</li>}
      </ul>
      <HowToFix code="schedule_conflict" testid="fix-schedule-conflict" details={items.map((i) => i.message).join(" | ")} />
      {hard && !detail.can_override && <p data-testid="sch-conflict-no-override" className="text-xs text-red-200">Only an admin or Super Admin can override this. Change the time or the people assigned instead.</p>}
      {(hard ? detail.can_override : true) && (
        <div className="flex flex-wrap gap-2 items-center">
          {hard && <input data-testid="sch-override-reason" className={`${field} flex-1 min-w-[180px]`} placeholder="Override reason (recommended)" value={reason} onChange={(e) => setReason(e.target.value)} />}
          <button type="button" onClick={() => onResolve({ override: hard, confirm_warnings: true, override_reason: reason })} data-testid={hard ? "sch-override-confirm" : "sch-warning-proceed"} className={hard ? btnRed : btnGold}>
            {hard ? "Override and save" : "Proceed anyway"}
          </button>
          <button type="button" onClick={onCancel} data-testid="sch-conflict-back" className={btnGold}>Go back</button>
        </div>
      )}
    </div>
  );
}
